import { graphql, useStaticQuery } from "gatsby"

const useSeoDefault = () => {
   const data = useStaticQuery(graphql`
      query {
         Payload {
            Pages(where: { slug: { equals: "seo-default" } }) {
               docs {
                  title
                  meta {
                     title
                     description
                     image {
                        url
                     }
                     keywords
                     robots
                     schemamk
                  }
               }
            }
         }
      }
  `);

  return data.Payload?.Pages?.docs?.[0]?.meta || {};
}

export default useSeoDefault;
